<template>
  <div class="form-item">
    <a-form-model-item class="correct-form-item" :class="{ required_: isMobile && fieldItem.required }" :label-col="labelCol" :wrapper-col="wrapperCol" :prop="formItemProp" :label="fieldItem.label">
      <!-- 如果控件是 Select -->
      <template v-if="fieldItem.type === 'select'">
        <a-select v-model="itemVal" :show-search="fieldItem.isSearch" :filter-option="filterOptions" :placeholder="fieldItem.writeable && !disabledAll ? '请选择' + fieldItem.label : ''" :disabled="!fieldItem.writeable || disabledAll" @change="value => fieldItem.changeFn && fieldItem.changeFn(value, fieldItem.key, editIndex)">
          <div v-if="isMobile" slot="suffixIcon">
            <img v-if="fieldItem.writeable && !disabledAll" class="mobile-select-arrow-icon" src="../../assets/images/xiala.png" alt="xiala" />
          </div>
          <a-select-option v-for="op in fieldItem.dataSource" :key="op.code" :value="op.code">{{ op.name }}</a-select-option>
        </a-select>
      </template>
      <!-- 如果控件是 Date -->
      <template v-else-if="fieldItem.type === 'date'">
        <a-date-picker class="datePicker_" v-model="itemVal" format="YYYY-MM-DD" :disabled-date="fieldItem.disabledDate" :allowClear="false" :placeholder="fieldItem.writeable && !disabledAll ? '请选择' + fieldItem.label : ''" :disabled="!fieldItem.writeable || disabledAll" @change="value => fieldItem.changeFn && fieldItem.changeFn(value, fieldItem.key, editIndex)" />
      </template>
      <!-- 默认是 Input -->
      <template v-else>
        <a-input v-model="itemVal" :placeholder="fieldItem.writeable && !disabledAll ? '请输入' + fieldItem.label : ''" :disabled="!fieldItem.writeable || disabledAll" @blur="e => fieldItem.blurFn && fieldItem.blurFn(e.target.value, fieldItem.key, editIndex)" @input="e => fieldItem.inputFn && fieldItem.inputFn(e.target.value, fieldItem.key, editIndex)" />
      </template>
    </a-form-model-item>
  </div>
</template>

<script>
export default {
  name: 'formItem',
  inject: ['isMobile', 'getDisabledAll'],
  props: {
    // 被保人配置项数据
    fieldItem: {
      type: Object,
      default: () => {}
    },
    // 修改的数据索引
    editIndex: {
      type: Number,
      default: 0
    },
    // 修改被保人Form表单数据
    editForm: {
      type: Object,
      default: () => {}
    },
    // form-item的prop
    formItemProp: {
      type: String,
      default: ''
    },
    // label占比
    labelCol: {
      type: Object,
      default: () => {}
    },
    // wrapper占比
    wrapperCol: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    // 动态设置绑定值
    itemVal: {
      get() {
        let key = this.fieldItem.key;
        let path = '';
        let value = '';
        if (!key.includes('.')) {
          value = this.editForm[key];
        } else {
          path = key.split('.')[0];
          key = key.split('.')[1];
          if (this.editForm[path]) {
            value = this.editForm[path][key];
          }
        }
        return value;
      },
      set(val) {
        if (this.fieldItem.key.includes('.')) {
          this.editForm[this.fieldItem.key.split('.')[0]][this.fieldItem.key.split('.')[1]] = val;
        } else {
          this.editForm[this.fieldItem.key] = val;
        }
      }
    },
    // 禁用
    disabledAll() {
      const disabled = this.getDisabledAll();
      return disabled && this.editForm.correctType !== '新增';
    }
  },
  methods: {
    // 下拉框过滤方法
    filterOptions(val, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.datePicker_ {
  width: 204px;
}
</style>
